module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/home-front-service-lvl2-100.1a24b97f.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/home-front-service-lvl2-100.png
// module id = 3537
// module chunks = 11